
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js";
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    var snoozeItems = document.querySelector('#SnoozeItems');
    var snoozeBtn = document.querySelector('#snoozebtn');
    var snoozeOpt = document.querySelector('.snooze-drop-option');

    if (snoozeItems?.classList.contains('opened') && !snoozeItems?.contains(e.target) && !snoozeOpt.contains(e.target) && !snoozeBtn?.contains(e.target)) {
      snoozeItems?.classList.remove('opened');
    }
  });
});
export default {
  data: function () {
    return {
      loginobject: {},
      thisConvo: {},
      ReplyConvID: ""
    };
  },
  methods: {
    openConversation: async function (uID, reservationID) {
      try {
        app.f7.preloader.show();
        var obj = {
          PropertyID: this.loginobject?.PropertyID,
          UserID: this.loginobject?.UserID,
          isMobile: true,
          uID,
          resID: reservationID
        };
        await app.f7.request.promise.post(URLS.GetConversation, {
          obj
        }).then(res => {
          this.thisConvo = JSON.parse(res?.data) || {};
          this.thisConvo?.Conversations.map(function (c) {
            c.extraClass = c.isInternalNote == true ? "internal-note" : '';
            return c;
          });
          this.thisConvo.isUnread = false;
          const uID = this.thisConvo?.ConnectionID;

          if (this.isIos()) {
            $$(".conversation-outer-wrapper").addClass("extra-retardito");
          }

          this.$setState({
            thisConvo: this.thisConvo
          });
        });
        console.log(this.thisConvo);
      } catch (err) {
        console.log(err);
      } finally {
        setTimeout(() => {
          this.scrollMessages();
        }, 100);

        if (this.thisConvo.ApiChannelID) {
          $$("#apichannelBtn").click();
        } else if (this.thisConvo.Email && this.isValidEmail(this.thisConvo.Email)) {
          $$("#emailBtn").click();
        } else if (this.thisConvo.Phone) {
          $$("#smsBtn").click();
        } else {
          $$("#internalNoteBtn").click();
        }

        app.f7.preloader.hide();
      }
    },

    isIos() {
      return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
      navigator.userAgent.includes("Mac") && "ontouchend" in document;
    },

    checkWhichActive: function (id) {
      $$('.conv-option').removeClass('active');
      $$(`#${id}`).addClass('active');
    },
    alertNoParameter: function (param) {
      var alertMessage = `No ${param}`;
      var toastWithCustomButton = app.f7.toast.create({
        text: alertMessage,
        closeButton: true,
        closeButtonText: 'Close Me',
        closeButtonColor: 'red'
      });
      toastWithCustomButton.open();
    },
    getReply: function (messageID) {
      var message = this.thisConvo.Conversations.filter(function (c) {
        return c.EmailID == messageID;
      });
      const thisMessage = message[0];
      $$("#reply-text").html(thisMessage.BodyTxt);
      $$("#reply-name-date").html(thisMessage.NameDate);
      this.ReplyConvID = messageID;
      this.$setState({
        ReplyConvID: this.ReplyConvID
      });
      $$("#reply-preview").addClass("open");
    },
    setNoReply: async function (messageID) {
      app.f7.preloader.show();
      await app.f7.request.promise.post(`${URLS.SetNoReply}?messageID=${messageID}`).then(res => {
        $$("#reply-options_" + messageID).remove();
      });
      app.f7.preloader.hide();
    },
    removeReply: function () {
      $$("#reply-preview").removeClass("open");
      $$("#reply-text").html("");
      $$("#reply-name-date").html("");
      this.ReplyConvID = "";
      this.$setState({
        ReplyConvID: this.ReplyConvID
      });
    },
    scrollMessages: function () {
      var objDiv = document.getElementById("messages");
      objDiv.scrollTop = objDiv.scrollHeight;
    },
    isValidEmail: function (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    GetSnoozeItems: function () {
      if ($$("#SnoozeItems").hasClass('opened')) {
        $$("#SnoozeItems").removeClass('opened');
      } else {
        $$("#SnoozeItems").addClass('opened');
      }
    },
    gotToReservation: function (reservationID) {
      try {
        localStorage.setItem("ReservationID", JSON.stringify(reservationID));
        app.f7.views.main.router.navigate('/reservation-info/', {
          transition: 'f7-dive'
        });
      } catch (err) {
        console.log(err);
      }
    },
    checkTyping: function () {
      const textQuary = $("#new-message-text").val();

      if (textQuary?.length > 0) {
        $$("#send-button").removeClass('inactive');
      } else {
        $$("#send-button").addClass('inactive');
      }
    },
    toggleResponses: function () {
      if ($$(".responses-wrapper").hasClass('hidden')) {
        $$(".responses-wrapper").removeClass('hidden');
        $$("#messages").addClass('smaller-wrapper-messages');
        this.scrollMessages();
      } else {
        $$(".responses-wrapper").addClass('hidden');
        $$("#messages").removeClass('smaller-wrapper-messages');
      }
    },
    pasteResponse: function (index) {
      const response = this.thisConvo.cannedResponses.Responses[index];

      if (response) {
        $$("#new-message-text").val(response.Text);
        this.checkTyping();
      } else {
        console.error("Response not found at index:", index);
      }
    },
    checkToUpdateConversation: async function () {
      const dt = new Date();

      const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

      const date = `${padL(dt.getDate())}/${padL(dt.getMonth() + 1)}/${dt.getFullYear()} ${padL(dt.getHours())}:${padL(dt.getMinutes())}:${padL(dt.getSeconds())}`;
      const uID = this.thisConvo?.ConnectionID;
      var obj = {
        PropertyID: this.loginobject?.PropertyID,
        UserID: this.loginobject?.UserID,
        isMobile: true,
        date,
        uID
      };
      await app.f7.request.promise.post(URLS.CheckRefreshConversation, {
        obj
      }).then(res => {
        const checkUpdate = res?.data;

        if (checkUpdate == "wrong date") {
          var toastCheckRates = app.f7.toast.create({
            text: checkUpdate,
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastCheckRates.open();
        } else {
          if (checkUpdate == "true") {
            this.openConversation(uID, this.thisConvo?.ReservationID);
          }
        }
      });
    }
  },
  on: {
    pageInit: function (e, page) {
      var self = this;
      var $ = self.$;
      self.loginobject = actions.LoginGetResult();
      self.$setState({
        loginobject: self.loginobject
      });
      $$(".page-content").addClass("p-0");
      $$(".page-content").addClass("ov-h");
      const conversationObj = JSON.parse(localStorage.getItem('converastion'));
      self.openConversation(conversationObj?.uID, conversationObj?.reservationID);
      window.checkToUpdateConversation = setInterval(function () {
        self.checkToUpdateConversation();
      }, 10000);
      $$("#send-button").on('click', async function () {
        try {
          app.f7.preloader.show();
          var bodyText = $$("#new-message-text").val();
          let apiChannelID = $$("#apichannelBtn").hasClass('active') ? $("#apichannelBtn").data('cid') : 0;
          let cID = $$("#apichannelBtn").hasClass('active') ? $("#apichannelBtn").data('acid') : "";
          let pID = $$("#apichannelBtn").hasClass('active') ? $("#apichannelBtn").data('pid') : "";
          var obj = {
            PropertyID: self.loginobject?.PropertyID,
            UserID: self.loginobject?.UserID,
            From: self.thisConvo?.Email,
            resID: self.thisConvo?.ReservationID,
            bodyText,
            isMobile: true,
            ReplyID: self.ReplyConvID,
            uID: self.thisConvo?.ConnectionID,
            apiChannelID,
            cID,
            pID
          };
          let urlToUse = URLS.SendEmailToCustomer;

          if ($$("#smsBtn").hasClass('active')) {
            urlToUse = URLS.AddSmsFromInbox;
          }

          if ($$("#viberBtn").hasClass('active')) {
            urlToUse = URLS.SendViber;
          }

          if ($$("#internalNoteBtn").hasClass('active')) {
            urlToUse = URLS.AddInternalNoteFromInbox;
          }

          if ($$("#apichannelBtn").hasClass('active')) {
            urlToUse = URLS.SendResponseToApiChannel;
          }

          await app.f7.request.promise.post(urlToUse, {
            obj
          }).then(res => {
            $$("#new-message-text").val("");
            setTimeout(() => {
              self.openConversation(res?.data, self.thisConvo?.ReservationID);
            }, 200);
          });
          self.removeReply();
          self.scrollMessages();
          $$(".responses-wrapper").addClass('hidden');
          $$("#messages").removeClass('smaller-wrapper-messages');
          $$("#send-button").addClass('inactive');
        } catch (err) {
          console.log(err);
        } finally {
          app.f7.preloader.hide();
        }
      });
      $$(".snooze-drop-option").on('click', async function () {
        app.f7.preloader.show();
        $$("#conv-snooze-icon").addClass("active-icon");
        var hours = $$(this).attr('data-hours');
        await app.f7.request.promise.post(`${URLS.SnoozeConvo}?uID=${self.thisConvo?.ConnectionID}&Hours=${hours}&PropertyID=${self.thisConvo?.PropertyID}&ReservationID=${self.thisConvo?.ReservationID}&CustomerID=${self.thisConvo?.CustomerID}`).then(res => {
          $$("#SnoozeItems").removeClass('opened');
          setTimeout(() => {
            self.openConversation(self.thisConvo?.ConnectionID, self.thisConvo?.ReservationID);
            var toastCheckRates = app.f7.toast.create({
              text: `Moved to snoozed for ${hours} hours`,
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastCheckRates.open();
          }, 200);
        });
        app.f7.preloader.hide();
      });
      $$("#mark-unread-btn").on('click', async function () {
        app.f7.preloader.show();
        $$("#conv-unread-icon").addClass("active-icon");
        await app.f7.request.promise.post(`${URLS.MarkAsUnreadNew}?uID=${self.thisConvo?.ConnectionID}&resID=${self.thisConvo?.ReservationID}`).then(res => {
          setTimeout(() => {
            var toastCheckRates = app.f7.toast.create({
              text: `Conversation marked as unread`,
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastCheckRates.open();
          }, 200);
        });
        app.f7.preloader.hide();
      });
      $$("#mark-fav-btn").on('click', async function () {
        app.f7.preloader.show();
        await app.f7.request.promise.post(`${URLS.MarkAsFav}?uID=${self.thisConvo?.ConnectionID}&resID=${self.thisConvo?.ReservationID}`).then(res => {
          setTimeout(() => {
            const isFav = !self.thisConvo?.isFav;
            self.thisConvo["isFav"] = isFav;
            self.$setState({
              thisConvo: self.thisConvo
            });
            var toastCheckRates = app.f7.toast.create({
              text: isFav ? `Conversation marked as favorite` : `Conversation removed from favorites`,
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastCheckRates.open();
          }, 200);
        });
        app.f7.preloader.hide();
      });
      $$("#mark-arch-btn").on('click', async function () {
        app.f7.preloader.show();
        await app.f7.request.promise.post(`${URLS.MarkAsArch}?uID=${self.thisConvo?.ConnectionID}&resID=${self.thisConvo?.ReservationID}`).then(res => {
          setTimeout(() => {
            const isArchive = !self.thisConvo?.isArchive;
            self.thisConvo["isArchive"] = isArchive;
            self.$setState({
              thisConvo: self.thisConvo
            });
            var toastCheckRates = app.f7.toast.create({
              text: isArchive ? `Conversation marked as archived` : `Conversation removed from archived`,
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastCheckRates.open();
          }, 200);
        });
        app.f7.preloader.hide();
      });
      $$("#mark-solved-btn").on('click', async function () {
        app.f7.preloader.show();
        await app.f7.request.promise.post(`${URLS.MarkAsSolved}?uID=${self.thisConvo?.ConnectionID}&resID=${self.thisConvo?.ReservationID}`).then(res => {
          setTimeout(() => {
            const isSolved = !self.thisConvo?.isSolved;
            self.thisConvo["isSolved"] = isSolved;
            self.$setState({
              thisConvo: self.thisConvo
            });
            var toastCheckRates = app.f7.toast.create({
              text: isSolved ? `Conversation marked as solved` : `Conversation removed from solved`,
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastCheckRates.open();
          }, 200);
        });
        app.f7.preloader.hide();
      });
    },
    pageBeforeOut: function (e, page) {
      clearInterval(window.checkToUpdateConversation);
      $$(".page-content").removeClass("p-0");
      $$(".page-content").removeClass("ov-h");
    }
  },
  id: '42fd6a3715',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i></a></div><div class="title sliding">Messages</div></div></div><div class=page-content><div class=conversation-wrapper><!-- <div class="section" style="padding-top: 55px;"> --><div class=section><div class=conversation-outer-wrapper><div class=coversation-header><div style="margin-left: 10px;"><div style="font-size: 20px;font-weight: 600;">';
      r += c(ctx_1.thisConvo?.CustomerName, ctx_1);
      r += '</div><div>';
      r += c(ctx_1.thisConvo?.ReservationDays, ctx_1);
      r += '</div><div class=ReservationStatus>';
      r += c(ctx_1.thisConvo?.ReservationStatus, ctx_1);
      r += '</div></div>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo?.ReservationID, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div style="margin-right: 10px;"><button class=reservation-details-btn @click=gotToReservation(';
          r += c(ctx_2.thisConvo?.ReservationID, ctx_2);
          r += ')>Details</button></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=coversation-option-button-wrapper><button id=snoozebtn type=button class=coversation-option-button color=plain style=min-width:auto; @click=GetSnoozeItems><i id=conv-snooze-icon class="material-icons coversation-icons ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo?.isSnooze, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'active-icon';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" style="font-size: large;">schedule</i><div class=dropdownCS-contentSnooze id=SnoozeItems><div class=snooze-drop-option data-hours=1>1 Hour</div><div class=snooze-drop-option data-hours=3>3 Hours</div><div class=snooze-drop-option data-hours=6>6 Hours</div><div class=snooze-drop-option data-hours=12>12 Hours</div><div class=snooze-drop-option data-hours=24>24 Hours</div><div class=snooze-drop-option data-hours=46>46 Hours</div></div></button> <button id=mark-unread-btn type=button class=coversation-option-button><span id=conv-unread-icon class="coversation-icons ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo?.isUnread, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'active-icon';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"><svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 32 32" aria-hidden=true role=presentation focusable=false style="display: block; height: 16px; width: 16px; fill: currentcolor;"><path d="M27 0a5 5 0 0 1 3 9v12a5 5 0 0 1-4.78 5h-5.06L16 31.08 11.84 26H7a5 5 0 0 1-4.98-4.56L2 21.22 2 21V7a5 5 0 0 1 4.78-5H23a5 5 0 0 1 4-2zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"></path></svg></span></button> <button id=mark-fav-btn type=button class=coversation-option-button><span id=conv-fav-icon class="coversation-icons ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo?.isFav, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'active-icon';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"><svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 32 32" aria-hidden=true role=presentation focusable=false style="display: block; height: 16px; width: 16px; fill: currentcolor;"><path fill-rule=evenodd d="m15.1 1.58-4.13 8.88-9.86 1.27a1 1 0 0 0-.54 1.74l7.3 6.57-1.97 9.85a1 1 0 0 0 1.48 1.06l8.62-5 8.63 5a1 1 0 0 0 1.48-1.06l-1.97-9.85 7.3-6.57a1 1 0 0 0-.55-1.73l-9.86-1.28-4.12-8.88a1 1 0 0 0-1.82 0z"></path></svg></span></button> <button id=mark-arch-btn type=button class=coversation-option-button><span id=conv-archive-icon class="coversation-icons ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo?.isArchive, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'active-icon';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"><svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 32 32" aria-hidden=true role=presentation focusable=false style="display: block; height: 16px; width: 16px; fill: currentcolor;"><path d="M30 12.5V28a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V12.5h28zm-7.06 2.41L16 21.85l-6.94-6.94-2.12 2.13 7.3 7.29.13.13a2.5 2.5 0 0 0 3.27-.01l.13-.12 7.3-7.3-2.13-2.12zM25.34 2a2 2 0 0 1 1.84 1.21l2.58 6.02a3 3 0 0 1 .1.27H2.14a3 3 0 0 1 .1-.27L4.82 3.2A2 2 0 0 1 6.66 2z"></path></svg></span></button> <button id=mark-solved-btn type=button class=coversation-option-button><i id=conv-solved-icon style="font-size: 19px;" class="material-icons coversation-icons ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo?.isSolved, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'active-icon';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '">check_box</i></button></div></div><div id=messages><div style="display: flex;justify-content: center;flex-direction: column;padding-top:5px;"><div style="margin-bottom: 10px;font-weight: 600;"><span>';
      r += c(ctx_1.thisConvo?.FirstDate, ctx_1);
      r += '</span></div><span style="display: flex;\n                                    flex-wrap: wrap;\n                                    align-items: center;">';
      r += c(ctx_1.thisConvo?.Title, ctx_1);
      r += '</span></div>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.thisConvo.Conversations, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div style="text-align: center;">';
          r += c(ctx_2.DateTimeOfEmailStr, ctx_2);
          r += ' ';
          r += c(ctx_2.TimeOfEmailStr, ctx_2);
          r += '</div><div class="';
          r += Template7Helpers.if.call(ctx_2, ctx_2.isFromProperty, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'property-message';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'customer-message';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '"><div style="max-width: 80%;"><!-- <div class="conv-title">\n                                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.LastName, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <span class="">';
              r += c(ctx_3.FirstName, ctx_3);
              r += ' ';
              r += c(ctx_3.LastName, ctx_3);
              r += '</span>\n                                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <span class="">';
              r += c(ctx_3.From, ctx_3);
              r += '</span>\n                                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                    <span>';
          r += c(ctx_2.TimeOfEmailStr, ctx_2);
          r += '</span>\n                                </div> --><div class="conv-body ';
          r += c(ctx_2.extraClass, ctx_2);
          r += '"><p>';
          r += c(ctx_2.Body, ctx_2);
          r += '</p></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class=section id=new-message><div id=composer-input class="">';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo.Email, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a @click="checkWhichActive(\'emailBtn\');" id=emailBtn class="conv-option active" data-channel=email><svg xmlns=http://www.w3.org/2000/svg height=24 viewBox="0 0 24 24" width=24><path d="M0 0h24v24H0z" fill=none></path><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path></svg> </a>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo.Phone, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a @click="checkWhichActive(\'smsBtn\');" id=smsBtn class=conv-option data-channel=chat><svg xmlns=http://www.w3.org/2000/svg height=24 viewBox="0 0 24 24" width=24><path fill=none d=M0,0h24v24H0V0z></path><path d=M12,3.7c-5.5,0-10,3.6-10,8c0,1.6,0.6,3.1,1.6,4.3c0,0,0.2,0.2,0.2,0.3c0,0-0.1-0.1-0.1-0.1l0,0l0,0l0,0c0.1,0.2,0.2,0.4,0.2,0.6c0,0.1-0.9,3-0.9,3l0,0c-0.1,0.2,0.1,0.5,0.4,0.5c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0l0.1,0l2.6-1.1c0,0,0.5-0.2,0.5-0.2l0,0c0,0,0,0,0,0c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c1.2,0.4,2.5,0.5,3.9,0.5c5.5,0,10-3.3,10-7.8C22,7.3,17.5,3.7,12,3.7L12,3.7z></path></svg> </a><a @click="checkWhichActive(\'viberBtn\');" id=viberBtn class=conv-option data-channel=viber><svg xmlns=http://www.w3.org/2000/svg height=24 width=24 viewBox="0 0 512 512"><path d="M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"></path></svg> </a>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <a @click="alertNoParameter(\'messenger\');" style=pointer-events:none; class=conv-option data-channel=messenger><svg height=24 viewBox="0 0 24 24" width=24 xmlns=http://www.w3.org/2000/svg class="css-0 e11k6mr30" style="min-width: 16px; min-height: 16px;"><path d="M0 0h24v24H0z" fill=none></path><path d="M12 2C6.4 2 2 6.1 2 11.7c0 2.9 1.2 5.4 3.1 7.2.2.1.3.4.3.6l.1 1.8c0 .6.6.9 1.1.7l2-.9c.1-.1.3-.1.5-.1.9.3 1.9.4 2.9.4 5.6 0 10-4.1 10-9.7S17.6 2 12 2zm6 7.5l-2.9 4.7c-.5.7-1.5.9-2.2.4l-2.3-1.8c-.2-.2-.5-.2-.7 0l-3.2 2.4c-.4.3-1-.2-.7-.6l2.9-4.7c.5-.7 1.5-.9 2.2-.4l2.3 1.8c.2.2.5.2.7 0l3.2-2.4c.4-.4 1 .1.7.6z"></path></svg> </a><a @click="checkWhichActive(\'internalNoteBtn\');" id=internalNoteBtn class=conv-option data-channel=internal-note><svg xmlns=http://www.w3.org/2000/svg width=24 height=24 viewBox="0 0 24 24" fill=none stroke=#8796af stroke-width=1.5 stroke-linecap=round stroke-linejoin=round><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1=12 y1=11 x2=12 y2=17></line><line x1=9 y1=14 x2=15 y2=14></line></svg> </a>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.thisConvo.ApiChannelName, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a @click="checkWhichActive(\'apichannelBtn\');" id=apichannelBtn class=conv-option data-acid=';
          r += c(ctx_2.thisConvo?.ApiConversationID, ctx_2);
          r += ' data-pid=';
          r += c(ctx_2.thisConvo?.ApiParticipantID, ctx_2);
          r += ' data-cid=';
          r += c(ctx_2.thisConvo?.ApiChannelID, ctx_2);
          r += ' data-channel=';
          r += c(ctx_2.thisConvo?.ApiChannelName, ctx_2);
          r += '><i class="CalIconSource SourceIcon_';
          r += c(ctx_2.thisConvo?.channelIncon, ctx_2);
          r += '"></i> <span class=api-channel-name>Text ';
          r += c(ctx_2.thisConvo?.ApiChannelName, ctx_2);
          r += '</span> </a>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div id=reply-preview><div role=none style="position: relative; display: flex; flex-direction: row; flex-grow: 1; flex-shrink: 1; overflow: hidden; align-items: stretch; margin: 5px 5px 0px;"><div role=none class="rxCustomScroll rxCustomScrollV" style="display: flex; flex: 1 1 0px; position: relative; overflow: hidden; box-sizing: border-box; align-self: stretch;"><div role=none style="position: relative; display: flex; flex-direction: row; flex-grow: 1; flex-shrink: 1; overflow: hidden; align-items: stretch; margin-right: 15px;"><div role=none aria-hidden=true style="position: relative; display: flex; flex-direction: row; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: stretch; margin-bottom: 4px;"><svg width=20 height=20 xmlns=http://www.w3.org/2000/svg viewBox="0 0 24 24" fill=#252423 gradientcolor1=#252423 gradientcolor2=#252423><path d="M9.277 7.779a.75.75 0 1 0-1.061-1.06l-4.997 5.003a.75.75 0 0 0 0 1.06l4.997 4.998a.75.75 0 0 0 1.061-1.06L5.557 13h7.842c1.595 0 2.81-.242 3.889-.764l.246-.126a6.203 6.203 0 0 0 2.576-2.576c.61-1.14.89-2.418.89-4.135a.75.75 0 0 0-1.5 0c0 1.484-.228 2.52-.713 3.428a4.702 4.702 0 0 1-1.96 1.96c-.838.448-1.786.676-3.094.709l-.334.004H5.562l3.715-3.721Z"></path></svg></div><div role=none style="position: relative; display: flex; overflow-wrap: break-word; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: hidden; align-items: stretch; padding-left: 20px;"><div role=none style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: hidden; align-items: stretch; max-height: 250px; align-self: stretch;"><div dir=auto style="position: relative; display: inline; flex-grow: 0; flex-shrink: 0; overflow: hidden; text-overflow: ellipsis; color: rgb(37, 36, 35); font-style: italic; padding-right: 4px; cursor: inherit;"><div id=reply-text dir=auto style="max-height: 180px;overflow: auto;position: relative; display: block; flex-grow: 0; flex-shrink: 0; text-overflow: ellipsis; font-size: 14px; line-height: 22px; letter-spacing: -0.2px;  color: rgb(37, 36, 35); align-self: stretch; background-color: rgba(0, 0, 0, 0); cursor: inherit;"></div></div></div><div id=reply-name-date></div></div></div></div><button role=button class=reply-close-btn @click=removeReply title="Κατάργηση αποσπάσματος" aria-label="Κατάργηση αποσπάσματος"><div role=none aria-hidden=true style="position: relative; display: flex; flex-direction: row; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: center; align-self: center; justify-content: center; background-color: rgba(0, 0, 0, 0);"><svg width=16 height=16 xmlns=http://www.w3.org/2000/svg viewBox="0 0 24 24" fill=#212121 gradientcolor1=#212121 gradientcolor2=#212121><path d="m4.397 4.554.073-.084a.75.75 0 0 1 .976-.073l.084.073L12 10.939l6.47-6.47a.75.75 0 1 1 1.06 1.061L13.061 12l6.47 6.47a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073L12 13.061l-6.47 6.47a.75.75 0 0 1-1.06-1.061L10.939 12l-6.47-6.47a.75.75 0 0 1-.072-.976l.073-.084-.073.084Z"></path></svg></div></button></div></div><div style="display: flex;align-items: center;padding: 0 5px;"><button class=send-action-button @click=toggleResponses><i id=conv-solved-icon style="font-size: 19px;color: #0566ff;" class="material-icons coversation-icons">mode_comment</i></button> <textarea id=new-message-text @input=checkTyping placeholder="Type your message here..."></textarea> <button id=send-button class="send-action-button inactive"><i id=conv-solved-icon style="font-size: 19px;color: #0566ff;" class="material-icons coversation-icons">send</i></button></div><div class="responses-wrapper hidden"><span class=response-title>Select Template</span><div class=response-inner-wrapper>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.thisConvo?.cannedResponses?.Responses, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=response-card @click="pasteResponse(';
          r += c(data_2 && data_2.index, ctx_2);
          r += ')"><div class=response-category>';
          r += c(ctx_2.Category, ctx_2);
          r += '</div><div class=response-text>';
          r += c(ctx_2.Text, ctx_2);
          r += '</div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .smaller-wrapper-messages {
        /* app android ios css */
        height: calc(100vh - 500px) !important;
        /* height: calc(100vh - 530px) !important; */
    }

    .hidden {
        display: none !important;
    }

    .response-category {
        font-size: 17px;
        color: #07c;
        margin-bottom: 5px;
    }

    .responses-wrapper {
        display: flex;
        flex-direction: column;
        padding: 10px 10px 0;
    }

    .response-title {
        margin: 5px 0;
        font-size: 16px;
    }

    .response-text {
        text-overflow: ellipsis;
        width: 100px;
        overflow: hidden;
        -webkit-line-clamp: 4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        max-height: 85px;
    }

    .response-inner-wrapper {
        display: flex;
        overflow-x: auto;
        max-height: 150px;
        overflow-y: hidden;
    }

    .response-card {
        display: flex;
        flex-direction: column;
        margin: 5px 10px;
        padding: 10px;
        border: 1px solid #07c;
        border-radius: 8px;
    }

    button.bui-link {
        border: 0;
        background: none;
        padding: 0;
        font-size: inherit;
        color: #07c;
        width: 120px;
        width: 105px;
        font-size: 13px;
        margin-left: 5px;
    }

    .bui-button {
        border: 1px solid #000;
        border-radius: 2px;
        display: inline-block;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 6px 10px;
        cursor: pointer;
        font-family: inherit;
        text-decoration: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        vertical-align: middle;
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.4285714286em;
    }

    .bui-button--primary {
        color: #fff;
        background-color: #07c;
        border-color: #07c;
        width: 50px;
        margin-left: 10px !important;
    }

    .conversation-message__pending-dot {
        width: 8px;
        height: 8px;
        fill: #fcb4b4;
        display: inline-block;
        vertical-align: middle;
    }

    .conversation-message__actions {
        font-size: 15px;
        margin-top: 8px;
        text-align: right;
        padding: 0 5px 5px 0px;
    }


    .inactive {
        pointer-events: none;
        opacity: 0.6;
    }

    #composer-input {
        display: flex;
        justify-content: space-evenly;
    }

    #composer-input svg {
        fill: rgb(135, 150, 175);
        width: 25px;
        height: 25px;
    }

    #composer-input .active {
        color: black;
        font-weight: 600;
    }

    #composer-input .active svg {
        fill: rgb(5, 102, 255);
    }

    .property-message {
        display: flex;
        flex-direction: row-reverse;
    }

    .customer-message {
        display: flex;
    }

    .customer-message .conv-body {
        background-color: #222222;
        color: white;
    }

    .reservation-details-btn {
        padding: 8px 12px;
        color: #fff;
        background-color: #07c;
        border: 0;
        font-size: 16px;
        border-radius: 3px;
    }

    .coversation-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }

    .ReservationStatus {
        color: #e69346;
    }

    .coversation-icons {
        color: #a9a8a8;
        fill: #a9a8a8;
    }

    .coversation-icons.active-icon {
        color: #000000;
        fill: #000000;
    }

    .coversation-icons.my-user-icon.active-icon {
        color: #34a1ff;
        fill: #34a1ff;
    }

    .snooze-drop-option {
        width: 60px;
        padding: 8px 5px;
        border-top: 1px solid #8a8d91;
    }

    .snooze-drop-option:first-child {
        border-top: 0;
    }

    .dropdownCS-contentSnooze {
        position: absolute;
        flex-direction: column;
        top: 25px;
        z-index: 999;
        display: none;
        background-color: #ededed;
        left: 0px;
        border: 1px solid #8a8d91;
        border-radius: 3px;
        box-shadow: rgb(4 17 30 / 80%) 0px 8px 24px;
    }

    .dropdownCS-contentSnooze.opened {
        display: flex;
    }

    .conversation-outer-wrapper {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        border-bottom: 1px solid #606060;
        background-color: #ededed;
        padding-top: 55px;
    }

    .conversation-outer-wrapper.extra-retardito {
        padding-top: 115px;
    }

    .coversation-option-button-wrapper {
        display: flex;
    }

    .coversation-option-button {
        opacity: 1 !important;
        -webkit-box-align: center !important;
        -webkit-box-pack: center !important;
        appearance: none !important;
        display: flex;
        border-radius: 50% !important;
        border: none !important;
        outline: none !important;
        margin: 0px !important;
        padding: 0px !important;
        color: #222222 !important;
        cursor: pointer !important;
        touch-action: manipulation !important;
        position: relative !important;
        background: transparent !important;
        transition: -ms-transform 0.25s cubic-bezier(0.2, 0, 0, 1), -webkit-transform 0.25s cubic-bezier(0.2, 0, 0, 1), transform 0.25s cubic-bezier(0.2, 0, 0, 1) !important;
        width: 35px !important;
        height: 35px !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .coversation-option-button::before {
        content: "" !important;
        display: block !important;
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        width: 40px !important;
        height: 40px !important;
        border-radius: 50% !important;
    }

    .internal-note {
        background-color: #E6E6FA !important;
    }

    .conv-option {
        display: flex;
        align-items: center;
        padding: 2px 5px 3px 3px;
        border-radius: 5px;
        margin-bottom: 5px;
    }

    #apichannelBtn.active {
        background: rgb(5, 102, 255);
    }

    .api-channel-name {
        color: black;
        font-weight: 600;
        display: inline-block;
        margin-left: 4px;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.01em;
    }

    #reply-preview {
        display: none;
        height: 0px;
        -webkit-transition: height, 0.5s linear;
        -moz-transition: height, 0.5s linear;
        -ms-transition: height, 0.5s linear;
        -o-transition: height, 0.5s linear;
        transition: height, 0.5s linear;
    }

    #reply-preview.open {
        display: flex;
        height: auto;
        -webkit-transition: height, 0.5s linear;
        -moz-transition: height, 0.5s linear;
        -ms-transition: height, 0.5s linear;
        -o-transition: height, 0.5s linear;
        transition: height, 0.5s linear;
    }

    #reply-name-date {
        position: relative;
        display: inline;
        flex-grow: 0;
        flex-shrink: 0;
        overflow: auto;
        white-space: pre-wrap;
        overflow-wrap: break-word;
        margin-top: 0px;
        margin-bottom: 0px;
        color: rgb(138, 141, 145);
        font-size: 12px;
        cursor: inherit;
        max-height: 160px;
    }

    .reply-close-btn {
        position: absolute;
        background-color: transparent;
        border-color: transparent;
        text-align: left;
        border-width: 0px;
        border-style: solid;
        padding: 3px;
        width: 20px;
        right: 0px;
        top: -5px;
    }

    .conv-title {
        background: #007bff;
        color: white;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    .conv-body {
        width: fit-content;
        margin-bottom: 15px;
        background-color: #ededed;
        padding: 5px 10px;
        border-radius: 8px;
    }

    .conv-body p {
        margin: 0;
    }

    #messages {
        /* app android ios css */
        height: calc(100vh - 310px);
        /* height: calc(100vh - 345px); */
        overflow-y: auto;
        padding: 0 10px;
    }

    .conversation-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
        overflow-y: hidden;
        position: relative;
    }

    .section h2 {
        margin-bottom: 10px;
    }

    #new-message {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #dddddd;
        padding-top: 5px;
        margin-bottom: 2px;
        position: absolute;
        bottom: 30px;
        width: 100%;
    }

    #new-message-text {
        width: 100%;
        height: 100px;
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        margin: 0 10px;
    }

    .send-action-button {
        background-color: transparent;
        color: #fff;
        border: none;
        border-radius: 15px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        border: 1px solid #0566ff;
        justify-content: center;
    }

    .p-0 {
        padding: 0 !important;
    }

    .ov-h {
        overflow: hidden;
    }
`,
  styleScoped: false
};
    